
import Swiper from 'swiper/swiper-bundle.min'
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
import { elementsOverlap } from '~/mixins/elementsOverlap'
import 'swiper/swiper-bundle.min.css'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin, elementsOverlap],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      matchMediaInstance: null,
      scrollTriggerInstance: null,
      swiperInstance: null,
      currentIndex: 0,
      mobileTextobject: [
        {
          title: 'FRESH AIR ACTIVITIES',
          text: 'Providing wellness breaks that support your holistic health, centering body and mind.',
        },
        {
          title: 'CREATING CONNECTIONS',
          text: 'Building bridges across the community with thoughtful networking and professional match-making.',
        },
        {
          title: 'EXPANDING PERSPECTIVES',
          text: 'Inspiring minds with progressive programming and fresh perspectives that spark market innovation and leave a lasting impression.',
        },
        {
          title: 'INTERWOVEN SUSTAINABILITY',
          text: 'Weaving sustainable practices into the event experience to simultaneously support people and planet.',
        },
        {
          title: 'REVITALIZING THE COMMUNITY',
          text: 'Generating a positive impact in host locations, replenishing the communities and places we touch down.',
        },
        {
          title: 'GENERATING POWER',
          text: 'Providing a platform to amplify community stories, collectively address critical issues and empower the next generation of leaders.',
        },
        {
          title: 'ADVANCING THE MOVEMENT',
          text: 'Rallying leaders around a shared vision, unlocking actionable strategies that advance the global movement.',
        },
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.matchMediaInstance = this.$gsap.matchMedia(this.$refs.container)

      this.matchMediaInstance.add('(max-width: 767px)', () => {
        this.initMobileSwiper()

        // return () => {
        //   this.initMobileSwiper?.destroy()
        // }
      })

      if (!this.blok.toggleStaticImage) {
        this.matchMediaInstance.add('(min-width: 768px)', () => {
          this.$gsap.to('.outer-ring-path', {
            transformOrigin: 'center',
            scale: 1.2,
            autoAlpha: 0,
            duration: 1,
            stagger: {
              repeat: -1,
            },
          })

          this.$gsap.set(
            ['.RechargeDifference--after', '.RechargeDifference--before'],
            {
              yPercent: 15,
            }
          )

          this.scrollTriggerInstance = this.$gsap.to(
            ['.RechargeDifference--after', '.RechargeDifference--before'],
            {
              opacity: 1,
              yPercent: -105,
              scrollTrigger: {
                trigger: this.$refs.container,
                start: 'top top',
                end: '+=300%', // bottom
                pin: this.$refs.container,
                pinType: 'fixed',
                // anticipatePin: 1,
                invalidateOnRefresh: true,
                // refreshPriority: -1,
                scrub: 0.5,
                // markers: true,
                onUpdate: (self) => {
                  // generating
                  this.hitTestIcon(
                    this.$refs.topLine,
                    this.$refs.bottomLine,
                    this.$refs.generating, // icon
                    self.direction
                  )
                  // expanding
                  this.hitTestIcon(
                    this.$refs.topLine,
                    this.$refs.bottomLine,
                    this.$refs.expanding, // icon
                    self.direction
                  )
                  // revitalizing
                  this.hitTestIcon(
                    this.$refs.topLine,
                    this.$refs.bottomLine,
                    this.$refs.revitalizing, // icon
                    self.direction
                  )
                  // advancing
                  this.hitTestIcon(
                    this.$refs.topLine,
                    this.$refs.bottomLine,
                    this.$refs.advancing, // icon
                    self.direction
                  )
                  // freshAir
                  this.hitTestIcon(
                    this.$refs.topLine,
                    this.$refs.bottomLine,
                    this.$refs.freshAir, // icon
                    self.direction
                  )
                  // interwoven
                  this.hitTestIcon(
                    this.$refs.topLine,
                    this.$refs.bottomLine,
                    this.$refs.interwoven, // icon
                    self.direction
                  )
                  // creating
                  this.hitTestIcon(
                    this.$refs.topLine,
                    this.$refs.bottomLine,
                    this.$refs.creating, // icon
                    self.direction
                  )
                },
              },
            }
          )

          this.$gsap.delayedCall(1, () => {
            // make sure scroll triggers are updated after render
            this.scrollTriggerInstance.scrollTrigger.refresh(true)
          })

          return () => {
            this.scrollTriggerInstance?.kill()
          }
        })
      }
    })
  },
  methods: {
    changeZIndex(e) {
      this.$gsap.to(['.RechargeDifference--after'], {
        duration: 0.2,
        zIndex: 1,
      })
      this.$gsap.to(e.target, {
        duration: 0.2,
        zIndex: 2,
      })
    },
    updateIndex(index) {
      this.currentIndex = index
    },
    initMobileSwiper() {
      this.swiperInstance = new Swiper(this.$refs.swiper, {
        slidesPerView: 'auto',
        // freeMode: true,
        spaceBetween: 16,
        grabCursor: true,
        keyboard: true,
        speed: 800,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        //   pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        //   },
        // scrollbar: {
        //   el: this.$refs.scrollbar,
        //   hide: true,
        // },
        // on: {
        //   realIndexChange: (swiper) => {
        //     console.log(swiper.realIndex)

        //     this.currentIndex = swiper.realIndex
        //   },
        //   // init: () => console.log('init text'),
        // },
      })
    },
    hitTestIcon(topLine, bottomLine, targetEl, direction) {
      if (this.$Draggable.hitTest(topLine, targetEl) && direction === 1) {
        // only call once
        if (!targetEl.classList.contains('pointer-events-auto')) {
          // enter
          targetEl.classList.add('pointer-events-auto')
          targetEl.classList.remove('pointer-events-none')

          targetEl.querySelector('.outer-ring').classList.add('opacity-100')
          targetEl.querySelector('.outer-ring').classList.remove('opacity-0')
        }
      } else if (
        this.$Draggable.hitTest(bottomLine, targetEl) &&
        direction === -1
      ) {
        // only call once
        if (!targetEl.classList.contains('pointer-events-none')) {
          // leave
          targetEl.classList.add('pointer-events-none')
          targetEl.classList.remove('pointer-events-auto')

          targetEl.querySelector('.outer-ring').classList.add('opacity-0')
          targetEl.querySelector('.outer-ring').classList.remove('opacity-100')
        }
      }
    },
  },
}
